export const SUB_TOTAL_ID = 0

export const CRITERIA = {
  CREDIT_RISK_SCORE: {
    key: 'CREDIT_RISK_SCORE',
    value: 'CorporateRiskScore',
    label: 'portfolio.summary.CREDIT_RISK_SCORE',
    isI18n: true,
  },
  PERFORMANCE_SCORE: {
    key: 'PERFORMANCE_SCORE',
    value: 'PerformanceScore',
    label: 'portfolio.summary.PERFORMANCE_SCORE',
    isI18n: true,
  },
  BUSINESS_SIZE_NET_REVENUE: {
    key: 'BUSINESS_SIZE_NET_REVENUE',
    value: 'BusinessSize',
    label: 'portfolio.summary.BUSINESS_SIZE_NET_REVENUE',
    shortLabel: 'portfolio.summary.BUSINESS_SIZE',
    isI18n: true,
  },
  YEARS_OF_OPERATION: {
    key: 'YEARS_OF_OPERATION',
    value: 'YearOfOperation',
    label: 'portfolio.summary.YEARS_OF_OPERATION',
    isI18n: true,
  },
}

const COLORS_6_10 = [
  ['#54BB7B', '#85D5A4', '#AFCE81', '#A28F76', '#98CAAB', '#F1F1F1'],
  ['#6DC78F', '#9CE0B6', '#C6DA95', '#BE9788', '#B2D7C0', '#F1F1F1'],
  ['#85D5A4', '#AFEBC6', '#DBE4A3', '#CEA69A', '#C6E2D1', '#F1F1F1'],
  ['#AFCE81', '#DBE4A3', '#FFDE86', '#F5A17C', '#EBDBB3', '#F1F1F1'],
  ['#A0C773', '#D6E199', '#FFDA79', '#F49A6D', '#EDD7A0', '#F1F1F1'],
  ['#A1A473', '#D2BA97', '#F9B779', '#EF786E', '#E6B4A4', '#F1F1F1'],
  ['#A28F76', '#CEA69A', '#F5A17C', '#EB6671', '#E2A0A6', '#F1F1F1'],
  ['#8C856A', '#BB9A8D', '#E2936E', '#D95A64', '#CF9398', '#F1F1F1'],
  ['#98CAAB', '#C6E2D1', '#EBDBB3', '#E2A0A6', '#D9D9D9', '#F1F1F1'],
  ['#F1F1F1', '#F1F1F1', '#F1F1F1', '#F1F1F1', '#F1F1F1', '#F1F1F1'],
]

const COLORS_10_6 = [
  [
    '#54BB7B',
    '#6DC78F',
    '#85D5A4',
    '#AFCE81',
    '#A0C773',
    '#A1A473',
    '#A28F76',
    '#8C856A',
    '#98CAAB',
    '#F1F1F1',
  ],
  [
    '#85D5A4',
    '#9CE0B6',
    '#AFEBC6',
    '#DBE4A3',
    '#D6E199',
    '#D2BA97',
    '#CEA69A',
    '#BB9A8D',
    '#C6E2D1',
    '#F1F1F1',
  ],
  [
    '#AFCE81',
    '#C6DA95',
    '#DBE4A3',
    '#FFDE86',
    '#FFDA79',
    '#F9B779',
    '#F5A17C',
    '#E2936E',
    '#EBDBB3',
    '#F1F1F1',
  ],
  [
    '#A28F76',
    '#BE9788',
    '#CEA69A',
    '#F5A17C',
    '#F49A6D',
    '#EF786E',
    '#EB6671',
    '#D95A64',
    '#E2A0A6',
    '#F1F1F1',
  ],
  [
    '#98CAAB',
    '#B2D7C0',
    '#C6E2D1',
    '#EBDBB3',
    '#EDD7A0',
    '#E6B4A4',
    '#E2A0A6',
    '#CF9398',
    '#D9D9D9',
    '#F1F1F1',
  ],
  [
    '#F1F1F1',
    '#F1F1F1',
    '#F1F1F1',
    '#F1F1F1',
    '#F1F1F1',
    '#F1F1F1',
    '#F1F1F1',
    '#F1F1F1',
    '#F1F1F1',
    '#F1F1F1',
  ],
]

const COLORS_5_10 = [
  ['#54BB7B', '#AFCE81', '#A28F76', '#98CAAB', '#F1F1F1'],
  ['#6DC78F', '#C6DA95', '#BE9788', '#B2D7C0', '#F1F1F1'],
  ['#85D5A4', '#DBE4A3', '#CEA69A', '#C6E2D1', '#F1F1F1'],
  ['#AFCE81', '#FFDE86', '#F5A17C', '#EBDBB3', '#F1F1F1'],
  ['#A0C773', '#FFDA79', '#F49A6D', '#EDD7A0', '#F1F1F1'],
  ['#A1A473', '#F9B779', '#EF786E', '#E6B4A4', '#F1F1F1'],
  ['#A28F76', '#F5A17C', '#EB6671', '#E2A0A6', '#F1F1F1'],
  ['#8C856A', '#E2936E', '#D95A64', '#CF9398', '#F1F1F1'],
  ['#98CAAB', '#EBDBB3', '#E2A0A6', '#D9D9D9', '#F1F1F1'],
  ['#F1F1F1', '#F1F1F1', '#F1F1F1', '#F1F1F1', '#F1F1F1'],
]

const COLORS_10_5 = [
  [
    '#54BB7B',
    '#6DC78F',
    '#85D5A4',
    '#AFCE81',
    '#A0C773',
    '#A1A473',
    '#A28F76',
    '#8C856A',
    '#98CAAB',
    '#F1F1F1',
  ],
  [
    '#AFCE81',
    '#C6DA95',
    '#DBE4A3',
    '#FFDE86',
    '#FFDA79',
    '#F9B779',
    '#F5A17C',
    '#E2936E',
    '#EBDBB3',
    '#F1F1F1',
  ],
  [
    '#A28F76',
    '#BE9788',
    '#CEA69A',
    '#F5A17C',
    '#F49A6D',
    '#EF786E',
    '#EB6671',
    '#D95A64',
    '#E2A0A6',
    '#F1F1F1',
  ],
  [
    '#98CAAB',
    '#B2D7C0',
    '#C6E2D1',
    '#EBDBB3',
    '#EDD7A0',
    '#E6B4A4',
    '#E2A0A6',
    '#CF9398',
    '#D9D9D9',
    '#F1F1F1',
  ],
  [
    '#F1F1F1',
    '#F1F1F1',
    '#F1F1F1',
    '#F1F1F1',
    '#F1F1F1',
    '#F1F1F1',
    '#F1F1F1',
    '#F1F1F1',
    '#F1F1F1',
    '#F1F1F1',
  ],
]

const COLORS_6_5 = [
  ['#87D4A4', '#A4D594', '#C1D895', '#B79E8B', '#A9CFB7', '#F1F1F1'],
  ['#C1D895', '#E1DA85', '#FFDE86', '#F5A47B', '#E6D4A7', '#F1F1F1'],
  ['#BDAF87', '#DBB077', '#F8B478', '#EF796D', '#DFAA99', '#F1F1F1'],
  ['#A9CFB7', '#C7D0A8', '#E6D4A7', '#DB989D', '#D9D9D9', '#F1F1F1'],
  ['#F1F1F1', '#F1F1F1', '#F1F1F1', '#F1F1F1', '#F1F1F1', '#F1F1F1'],
]

const COLORS_5_6 = [
  ['#87D4A4', '#C1D895', '#BDAF87', '#A9CFB7', '#F1F1F1'],
  ['#A4D594', '#E1DA85', '#DBB077', '#C7D0A8', '#F1F1F1'],
  ['#C1D895', '#FFDE86', '#F8B478', '#E6D4A7', '#F1F1F1'],
  ['#B79E8B', '#F5A47B', '#EF796D', '#DB989D', '#F1F1F1'],
  ['#A9CFB7', '#E6D4A7', '#DFAA99', '#D9D9D9', '#F1F1F1'],
  ['#F1F1F1', '#F1F1F1', '#F1F1F1', '#F1F1F1', '#F1F1F1'],
]

const COLORS_6_6 = [
  ['#87D4A4', '#A4D594', '#C1D895', '#B79E8B', '#A9CFB7', '#F1F1F1'],
  ['#A4D594', '#C3D785', '#E1DA85', '#D79C7A', '#C7D0A8', '#F1F1F1'],
  ['#C1D895', '#E1DA85', '#FFDE86', '#F5A47B', '#E6D4A7', '#F1F1F1'],
  ['#BDAF87', '#DBB077', '#F8B478', '#EF796D', '#DFAA99', '#F1F1F1'],
  ['#A9CFB7', '#C7D0A8', '#E6D4A7', '#DB989D', '#D9D9D9', '#F1F1F1'],
  ['#F1F1F1', '#F1F1F1', '#F1F1F1', '#F1F1F1', '#F1F1F1', '#F1F1F1'],
]

export const mapColors = (xTicks, yTicks) => {
  const colorMatrixMap = {
    '5_6': COLORS_5_6,
    '6_5': COLORS_6_5,
    '6_6': COLORS_6_6,
    '5_10': COLORS_5_10,
    '10_5': COLORS_10_5,
    '6_10': COLORS_6_10,
    '10_6': COLORS_10_6,
  }

  const key = `${xTicks.length}_${yTicks.length}`
  return colorMatrixMap[key] || []
}
